var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.625 10.792a1.542 1.542 0 1 1 3.084 0 1.542 1.542 0 0 1-3.084 0Zm0 7.708a1.542 1.542 0 1 1 3.085.001 1.542 1.542 0 0 1-3.085-.001Zm1.542 6.167a1.542 1.542 0 1 0 0 3.084 1.542 1.542 0 0 0 0-3.084Zm6.067-7.709h18.699c.794 0 1.443.65 1.443 1.443v.198c0 .794-.65 1.443-1.443 1.443h-18.7c-.793 0-1.44-.65-1.44-1.443V18.4c0-.794.647-1.443 1.44-1.443Zm18.699 7.709h-18.7c-.793 0-1.44.649-1.44 1.443v.197c0 .794.647 1.443 1.44 1.443h18.7c.794 0 1.443-.649 1.443-1.443v-.197c0-.794-.65-1.443-1.443-1.443ZM12.233 9.25h18.7c.794 0 1.443.649 1.443 1.443v.197c0 .794-.65 1.443-1.443 1.443h-18.7a1.446 1.446 0 0 1-1.44-1.443v-.197c0-.794.647-1.443 1.44-1.443Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLists);
export default __webpack_public_path__ + "static/media/lists.068563ae64adb161b3b5d3246d1bd423.svg";
export { ForwardRef as ReactComponent };